<template>
  <div>
    <rate-modifier-storage-table
        :static-mode="staticMode"
        :model="model"
        :disabled="disabled"
        code
        portal
        @change="handleChange"
    />
  </div>
</template>

<script>
// Components
import RateModifierStorageTable from './RateModifierStorageTable.vue'

export default {
  name: 'RateModifierStorageChargeRow',
  emits: ['change', 'delete'],
  components: {
    RateModifierStorageTable
  },
  props: {
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    keywords: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default () {
        return ''
      }
    },
    removeBtn: {
      type: Boolean,
      default () {
        return false
      }
    },
    staticMode: {
      type: Boolean,
      default () {
        return false
      }
    },
    model: {
      type: Object,
      default () {
        return {
          code: 0,
          name: '',
          comment: '',
          conditions: [],
          period: "month",
          periodCount: 1,
          rates: []
        }
      }
    }
  },
  data () {
    return {
      names: {
        'products': 'Products',
        'items': 'Items',
        'palletized': 'Pallets',
        'batch': 'Batch & EXP'
      }
    }
  },
  methods: {
    handleInsert (option, editor) {
      const data = {
        content: option.name,
        props: {
          style: 'background: orange;',
          'data-id': option.id
        }
      }

      editor.plugins.span.insert(data)
    },
    handleSurcharges (surcharges) {
      this.handleChange({ ...this.model, surcharges })
    },
    handleDelete (model) {
      this.$emit('delete', model)
    },
    handleChange (model) {
      this.$emit('change', model)
    }
  }
}
</script>
